import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axiosInstance from "../services/baseurl";
import logo from "../assets/images/round_logo.png";
import styles from "../css/dashboardTopNav.module.css";

const destinations = [
  ["/dashboard", "Overview"],
  ["/uploads", "Collections"],
  ["/crateBatch", "Create batch"],
  ["/updateBatch", "Update batch"],
  ["/transactions", "Transactions"],
  ["/userlist", "Users"],
];

export default function TopNavbar() {
  const [open, setOpen] = useState(false);
  const name = sessionStorage.getItem("name") || "Admin";
  useEffect(() => {
    if (!open) return;
    const closeOnEscape = event => { if (event.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open]);
  const logout = () => {
    ["name", "userId", "token"].forEach(key => sessionStorage.removeItem(key));
    delete axiosInstance.defaults.headers.common.Authorization;
    setOpen(false);
  };
  return <header className={styles.header}>
    <div className={styles.bar}>
      <Link to="/dashboard" className={styles.brand} aria-label="Buyandwin dashboard" onClick={() => setOpen(false)}>
        <img src={logo} alt="" />
        <span>buy<span>&</span>win<small>ADMIN WORKSPACE</small></span>
      </Link>
      <nav id="dashboard-navigation" aria-label="Dashboard navigation" className={`${styles.navigation} ${open ? styles.open : ""}`}>
        {destinations.map(([path, label]) => <NavLink key={path} to={path} end className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`} onClick={() => setOpen(false)}>{label}</NavLink>)}
      </nav>
      <div className={styles.account}>
        <span className={styles.avatar} aria-hidden="true">{name.charAt(0).toUpperCase()}</span>
        <div className={styles.identity}><span title={name}>{name}</span><small>Administrator</small></div>
        <Link to="/" onClick={logout} className={styles.logout}>Log out <span aria-hidden="true">&#8599;</span></Link>
      </div>
      <button type="button" className={styles.toggle} aria-label={open ? "Close navigation" : "Open navigation"} aria-expanded={open} aria-controls="dashboard-navigation" onClick={() => setOpen(previous => !previous)}>
        {open ? <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg> : <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16" /></svg>}
      </button>
    </div>
  </header>;
}
